import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Header, Text, Image } from '@gasbuddy/react-components';
import BadgeAdImage from '../BadgeImage';

import { noop } from '../../../lib/utils';

export default function BadgeModalContent({
  imageUrl,
  title,
  description,
  detailsImageUrl,
  callToAction,
  targetUrl,
  clickTrackingUrl,
  onCTAClick,
}) {
  const handleCtaClick = useCallback(() => {
    onCTAClick();
    axios.get(clickTrackingUrl);
  }, [onCTAClick, clickTrackingUrl]);

  let formattedTargetUrl;
  // keep targetUrl as undefined if it isn't available
  if (targetUrl) {
    formattedTargetUrl = targetUrl.startsWith('http://') ? targetUrl.replace(/http:\/\//, '') : targetUrl;
    formattedTargetUrl = formattedTargetUrl.startsWith('https://') ? formattedTargetUrl : `https://${formattedTargetUrl}`;
  }

  return (
    <React.Fragment>
      <Header as="h3">{title}</Header>
      <br />
      <Text as="p" centered>
        <BadgeAdImage src={imageUrl} alt={title} large />
      </Text>
      <br />
      <br />
      {!!description && (
        <Text as="p">{description}</Text>
      )}
      {!!detailsImageUrl && (
        <React.Fragment>
          <Image src={detailsImageUrl} alt={detailsImageUrl} />
          <br />
        </React.Fragment>
      )}
      {callToAction && targetUrl && (
        <Button
          primary
          as="a"
          href={formattedTargetUrl}
          target="_blank"
          onClick={handleCtaClick}
        >
          {callToAction}
        </Button>
      )}
    </React.Fragment>
  );
}

BadgeModalContent.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.node,
  detailsImageUrl: PropTypes.string,
  callToAction: PropTypes.string,
  targetUrl: PropTypes.string,
  clickTrackingUrl: PropTypes.string,
  onCTAClick: PropTypes.func,
};

BadgeModalContent.defaultProps = {
  imageUrl: undefined,
  title: undefined,
  description: undefined,
  detailsImageUrl: undefined,
  callToAction: undefined,
  targetUrl: undefined,
  clickTrackingUrl: undefined,
  onCTAClick: noop,
};

BadgeModalContent.displayName = 'BadgeModalContent';
